import { render, staticRenderFns } from "./ProfileData.vue?vue&type=template&id=7a6cdf0b"
import script from "./ProfileData.vue?vue&type=script&lang=js"
export * from "./ProfileData.vue?vue&type=script&lang=js"
import style0 from "./ProfileData.vue?vue&type=style&index=0&id=7a6cdf0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports